/*
 * FileUploader.vue
 * A Vue component for uploading files with drag-and-drop support.
 * Allows multiple file selection and displays selected files with an option to remove them.
 *
 * This component is controlled via 'Web Interface Control' repo
 *
 * Version: 1.0.1
 */


<template>
  <div
    class="file-uploader"
    @dragover.prevent="onDragOver"
    @dragleave.prevent="onDragLeave"
    @drop.prevent="onDrop"
    :class="{ 'dragging': isDragging }"
    @click="triggerFileSelect"
  >
    <input
      type="file"
      ref="fileInput"
      :multiple="multiple"
      class="hidden-input"
      @change="onFileChange"
    />

    <p v-if="!files.length">
      Drag & drop {{ props.multiple ? 'files' : 'your file' }} here, or click to select
    </p>

    <ul v-else>
      <li v-for="(file, index) in files" :key="file.name + index" class="file-item">
        <span>{{ file.name }}</span>
        <button type="button" @click.stop="removeFile(index)">✖</button>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  multiple: {
    type: Boolean,
    default: true
  },
  folderName: {
    type: String,
    default: ''
  }
})

const isDragging = ref(false)
const files = ref([])
const fileInput = ref(null)

function onDragOver() {
  isDragging.value = true
}

function onDragLeave() {
  isDragging.value = false
}

function onDrop(event) {
  isDragging.value = false
  handleFiles(event.dataTransfer.files)
}

function onFileChange(event) {
  handleFiles(event.target.files)
  event.target.value = '' // reset so same file can be re-added
}

function triggerFileSelect() {
  fileInput.value.click()
}

function handleFiles(selectedFiles) {
  const newFiles = Array.from(selectedFiles);

  if (!props.multiple) {
    // Only allow one file: replace the current array with the first file
    if (newFiles.length > 0) {
      files.value = [newFiles[0]];
    }
  } else {
    // Add new files without duplicates
    newFiles.forEach(file => {
      if (!files.value.some(f => f.name === file.name && f.size === file.size)) {
        files.value.push(file);
      }
    });
  }
}


function removeFile(index) {
  files.value.splice(index, 1)
}



import { postFile } from '@/services/blobstoragecommunicator.func.js';



const uploadToBlobStorage = async () => {

    const responses = [];
    try {
        for (const file of files.value) {
            const formData = new FormData();
            const timestamp = new Date().toISOString().replace(/[-:.TZ]/g, '');
            const guid = crypto.randomUUID();
            const fileName = `${timestamp}_${guid}_${file.name}`;
            formData.append('file', file);

            
            const folderName = `implementationclient-${props.folderName}`;
            const response = await postFile(formData, folderName, fileName);
            responses.push(response);
        }
        return responses;
    } catch (err) {
        console.error('Error uploading files:', err);
        throw err;
    }
};

defineExpose({ uploadToBlobStorage });

</script>

<style scoped>
.file-uploader {
  border: 2px dashed #ccc;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: background 0.3s;

  display: flex;
  flex-direction: column; /* Keep files stacked vertically */
  align-items: center;
  justify-content: center;
  min-height: 150px; /* Ensures enough space for centering */
}
.file-uploader.dragging {
  background-color: #f0f0f0;
}
.hidden-input {
  display: none;
}
.file-item {
  display: flex;
  align-items: center;
  gap: 10px; 
  margin-top: 8px; 
  padding: 4px 8px;    
  border: 1px solid #eee; 
  border-radius: 6px;  
  width: 100%;
  max-width: 400px;
}

.file-item button {
  background: transparent;
  border: none;
  color: red;
  font-size: 16px;
  cursor: pointer;
}



.file-item span {
  flex-grow: 1;        /* let filename take remaining space gracefully */
  word-break: break-all; /* prevents long names from breaking layout */
}

.file-item button {
  margin-left: 8px;    /* ensure some spacing from filename */
  background: transparent;
  border: none;
  color: red;
  font-size: 16px;
  cursor: pointer;
}


</style>
